import { Box, BoxProps, Heading, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ERoutes } from "Router/types";
import { ISearch } from "types";
import { SearchHeading } from "./SearchHeading";

interface Props extends BoxProps {
  contacts: ISearch["contacts"];
}

export const Contacts = ({ contacts, ...boxProps }: Props) => {
  const { t } = useTranslation();
  if (contacts.length === 0) return null;
  return (
    <Box {...boxProps}>
      <SearchHeading>{t("Contacts")}</SearchHeading>
      {contacts.map((contact) => (
        <LinkBox key={contact.contactId} _hover={{ bg: "gray.200" }} px="1" py="2">
          <Text fontWeight="semibold">
            <LinkOverlay as={Link} to={`${ERoutes.supplier}/${contact.companyId}/contacts`}>
              {contact.contactName}
            </LinkOverlay>
          </Text>
          <Text fontSize="small">{contact.companyName}</Text>
        </LinkBox>
      ))}
    </Box>
  );
};
